import { TutorialDefinition } from '../../../types/tutorial';

export const emptyDashboardTutorial: TutorialDefinition = {
  id: 'empty-dashboard',
  initialAnimation: 'top-left',
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to VeriVox!',
      content:
        "<p>Let's get you started with a quick tour. You can upload audio or video files to transcribe and edit them.</p>",
      placement: 'center',
    },
    {
      id: 'create-folder',
      targetSelector: '[title="Create folder"]',
      title: 'Organize with folders',
      content:
        '<p>Click here to create folders to organize your files. You can create as many folders as you need to keep your projects organized.</p>',
      placement: 'right',
      offsetX: 10,
    },
    {
      id: 'upload-files',
      targetSelector: '[data-tutorial="upload-area"]',
      title: 'Upload your files',
      content:
        '<p>Drag and drop audio or video files here to upload them. You can also click to browse your files. Supported formats include MP3, WAV, MP4, and more.</p>',
      placement: 'bottom',
      offsetY: 10,
    },
    {
      id: 'file-tree',
      targetSelector: '[data-tutorial="file-tree"]',
      title: 'Navigate your files',
      content:
        '<p>Your uploaded files will appear here in the file tree. Click on any file to view and edit its transcript. Drag and drop files between folders to reorgnize them.</p>',
      placement: 'right',
      offsetX: 10,
    },
  ],
};
